import React from "react";
import { Link } from "react-router-dom";

const FitnessVideos = () => {
  const videos = [
    { id: "m3v3PN5bvZo", title: "Power Walking Workout" },
    { id: "vbJxymW5xj0", title: "Full Body Home Workout" },
    { id: "rKDoGD1-fgI", title: "Burn Arm + Leg + Belly Fat Workout" },
    { id: "QvE69Q1ugFU", title: "Full Body Workout" },
    { id: "snoKledrPo0", title: "Cardio Workout" },
    { id: "M0uO8X3_tEA", title: "Full Body Cardio Workout" },
    { id: "O2EY79Ys_qg", title: "15 Minute Yoga" },
    { id: "4ZBUDd4bsyA", title: "Daily Yoga Routine" },
  ];

  return (
    <>
      <section className="pt-[180px] max-md:pt-[130px] pb-[80px] relative max-lg:bg-[right_center] bg-[#f4f4f4] about-banner overflow-hidden">
        <div className="container">
          <div className="row items-center">
            <div className="w-full">
              <div className="relative max-md:text-center">
                <h2 className="text-[92px] max-md:text-[50px] font-bold capitalize font-sora text-secondary leading-[1.2]">
                  Fitness Videos
                </h2>
                <img
                  src="assets/img/shap-three-1.png"
                  alt="banner-shap"
                  className="absolute w-46 w-35 -top-[30px] -left-[32px] max-md:hidden animate-topshap"
                />
              </div>
              <ol className="mb-[16px] flex items-center max-md:justify-center max-md:mb-[40px] pt-[20px] max-md:hidden">
                <li className="text-[22px] text-secondary font-sora capitalize">
                  <Link to="/"> Home </Link>
                </li>
                <li
                  className="text-[22px] text-gary capitalize before:content-['-'] before:float-left before:text-gary before:px-[10px]"
                  aria-current="page"
                >
                  Fitness Videos
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section id="h4-pricing" className="relative w-full overflow-hidden">
        <div className="w-full h4-pricing-wrapper max-md:px-[30px] pb-[80px] md:pb-[80px] max-md:pt-[60px] md:pt-[80px] pricing_section_bg">
          <div className="container mx-auto px-4 relative z-20">
            {/* Videos Start Here */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {videos.map((video, index) => (
                <div
                  key={index}
                  className="video-card bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 w-full"
                >
                  <div
                    className="relative w-full block"
                    style={{ paddingTop: "56.25%" }}
                  >
                    <iframe
                      className="absolute inset-0 w-full h-full block"
                      src={`https://www.youtube.com/embed/${video.id}?rel=0`}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                      loading="lazy"
                    ></iframe>
                  </div>
                  <div className="p-5">
                    <h3 className="text-[20px] font-sora font-semibold text-secondary capitalize m-0">
                      {video.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
            {/* Videos End Here */}
          </div>

          <div className="shape-1 absolute left-40 top-96 z-0 pointer-events-none">
            <img src="assets/images/home-four/shape-1.webp" alt="" />
          </div>
          <div className="shape-2 absolute right-96 top-96 z-0 pointer-events-none">
            <img src="assets/images/home-four/shape-2.webp" alt="" />
          </div>
          <div className="shape-3 absolute left-96 top-[550px] z-0 pointer-events-none">
            <img src="assets/images/home-four/shape-3.webp" alt="" />
          </div>
          <div className="shape-4 absolute right-96 top-[550px] z-0 pointer-events-none">
            <img src="assets/images/home-four/shape-4.webp" alt="" />
          </div>
        </div>
      </section>
    </>
  );
};

export default FitnessVideos;